/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path ui/errors
 * @description Error boundary for the application
 */
import ErrorBoundary from "./ErrorBoundary";
export { ErrorBoundary };
export { ErrorFallbackView, ErrorWithStatusView } from "./components";
export type { ErrorBoundaryProps, ErrorBoundaryState, ErrorFallbackViewProps, ErrorWithStatusProps } from "./types";
export default ErrorBoundary;
